import { pantryColors } from '@pantry/ui'
import React from 'react'

const p = pantryColors

interface RuleRowProps {
  name: string
  description: string
  control: React.ReactNode
  isLast?: boolean
}

export const RuleRow: React.FC<RuleRowProps> = ({
  name,
  description,
  control,
  isLast,
}) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      padding: '10px 0',
      borderBottom: isLast ? 'none' : `1px solid ${p.gray[50]}`,
    }}
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        flex: 1,
        minWidth: 0,
      }}
    >
      <div style={{ fontSize: 13, fontWeight: 500, color: p.gray[700] }}>
        {name}
      </div>
      <div style={{ fontSize: 11.5, color: p.gray[400], lineHeight: 1.4 }}>
        {description}
      </div>
    </div>
    <div
      style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}
    >
      {control}
    </div>
  </div>
)
